import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

/**
 * Generated class for the InputTextComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "input-text",
  templateUrl: "input-text.html",
})
export class InputText {
  @Input() group: FormGroup;
  @Input() config;
  id: string;
  componentId: string;
  labelHeaderStyle: string;
  label: string;
  labelTextStyle: string;
  labelText: any;

  constructor(public translatePipe: TranslateService) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.labelHeaderStyle = this.config.labelHeaderStyle;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    this.labelTextStyle = this.config.labelTextStyle;
    this.labelText = this.config.labelText;
    this.labelText = this.group.controls[this.id].value;
    if (this.label === "frequency") {
      let finalValue = "";
      if (this.labelText) {
        if (this.labelText.hasOwnProperty("numerator")) {
          finalValue +=
            this.labelText.numerator +
            this.translatePipe.instant(" time(s) per ");
        }

        if (this.labelText.hasOwnProperty("denominator")) {
          finalValue += this.labelText.denominator + " ";
        }

        if (this.labelText.hasOwnProperty("timeUnit")) {
          finalValue += this.translatePipe.instant(this.labelText.timeUnit);
        }
      }

      this.labelText = finalValue;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/input-text/input-text.ts